"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactCountdown = _interopRequireDefault(require("react-countdown"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _Toggle = _interopRequireDefault(require("../helpers/Toggle"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _constants = require("../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var _renderer = function renderer(_ref, completedText, openingTypeText) {
  var days = _ref.days,
    hours = _ref.hours,
    minutes = _ref.minutes,
    seconds = _ref.seconds,
    completed = _ref.completed;
  if (completed) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      className: "d8-u-color-white",
      href: "/browse"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, completedText));
  }
  var openingText = 'Bookings Open In';
  if (openingTypeText === 'price_increase') {
    openingText = 'Prices Increase In';
  }
  // let text;
  // if (days) {
  //   text = `${days} day${days > 1 ? 's' : ''} until ${openingTypeText} open!`;
  // } else if (hours) {
  //   text = `${hours} hour${hours > 1 ? 's' : ''} until ${openingTypeText} open!`;
  // } else if (minutes) {
  //   text = `${minutes} minute${minutes > 1 ? 's' : ''} until ${openingTypeText} open!`;
  // } else {
  //   text = `${seconds} second${seconds > 1 ? 's' : ''} until ${openingTypeText} open!`;
  // }
  //   Old timer work - may still be useful in the future for sorting hours/hour etc. (Thanks Tom)

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-color-white flex justify-center items-center items-end@sm"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "d8-u-font-size-base d8-u-font-weight-500 text-md@sm"
  }, openingText, ": \xA0 \xA0"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-center items-center items-end@sm flex-column flex-row@sm"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "d8-u-line-height-1 text-xl d8-u-font-weight-500"
  }, days), /*#__PURE__*/_react["default"].createElement("span", {
    className: "margin-left-xs@sm text-sm"
  }, "DAYS ")), /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-md margin-x-xs"
  }, "|"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-center items-center items-end@sm flex-column flex-row@sm"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "d8-u-line-height-1 text-xl d8-u-font-weight-500"
  }, hours), /*#__PURE__*/_react["default"].createElement("span", {
    className: "margin-left-xs@sm text-sm"
  }, "HOURS ")), /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-md margin-x-xs"
  }, "|"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-center items-center items-end@sm flex-column flex-row@sm"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "d8-u-line-height-1 text-xl d8-u-font-weight-500"
  }, minutes), /*#__PURE__*/_react["default"].createElement("span", {
    className: "margin-left-xs@sm text-sm"
  }, "MINUTES ")));
};
var StickyCountdown = /*#__PURE__*/function (_Component) {
  function StickyCountdown() {
    var _this;
    (0, _classCallCheck2["default"])(this, StickyCountdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, StickyCountdown, [].concat(args));
    (0, _defineProperty2["default"])(_this, "state", {
      showCountdown: true
    });
    (0, _defineProperty2["default"])(_this, "hideCountdown", function () {
      if (_jsCookie["default"].get('hide_countdown_banner') === undefined) {
        _jsCookie["default"].set('hide_countdown_banner', true, {
          expires: 1
        });
      }
      _this.setState({
        showCountdown: false
      });
    });
    return _this;
  }
  (0, _inherits2["default"])(StickyCountdown, _Component);
  return (0, _createClass2["default"])(StickyCountdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (_jsCookie["default"].get('hide_countdown_banner') === 'true') {
        this.hideCountdown();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var showCountdown = this.state.showCountdown;
      var _this$props = this.props,
        dateTime = _this$props.dateTime,
        completedText = _this$props.completedText,
        openingTypeText = _this$props.openingTypeText,
        isCloseButtonHidden = _this$props.isCloseButtonHidden,
        moveCountdownDown = _this$props.moveCountdownDown;
      if (showCountdown) {
        return /*#__PURE__*/_react["default"].createElement(_Toggle["default"], {
          on: true
        }, function (_ref2) {
          var toggle = _ref2.toggle,
            on = _ref2.on;
          return on && /*#__PURE__*/_react["default"].createElement("div", {
            className: "d8-c-sticky-countdown text-center d8-u-black-bg d8-u-component-padding flex flex-center position-sticky bottom-0 width-100% d8-u-zindex-fixed-element",
            style: moveCountdownDown && {
              marginTop: window.innerHeight - 80
            }
          }, /*#__PURE__*/_react["default"].createElement(_reactCountdown["default"], {
            date: dateTime,
            renderer: function renderer(libProps) {
              return _renderer(libProps, completedText, openingTypeText);
            },
            zeroPadLength: 0
          }), !isCloseButtonHidden && /*#__PURE__*/_react["default"].createElement("div", {
            className: "margin-left-md inline-block"
          }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
            icon: "cross",
            buttonType: _constants.BUTTON_TYPES.BARE_WHITE_NO_PADDING,
            onClick: function onClick() {
              _this2.hideCountdown();
              toggle();
            },
            buttonSize: _constants.BUTTON_SIZES.MEDIUM
          })));
        });
      }
      return null;
    }
  }]);
}(_react.Component);
StickyCountdown.propTypes = {
  dateTime: _propTypes["default"].string.isRequired,
  completedText: _propTypes["default"].string,
  openingTypeText: _propTypes["default"].string,
  isCloseButtonHidden: _propTypes["default"].bool,
  moveCountdownDown: _propTypes["default"].bool
};
StickyCountdown.defaultProps = {
  completedText: 'Bookings are open!',
  openingTypeText: 'bookings'
};
_renderer.propTypes = {
  days: _propTypes["default"].number,
  hours: _propTypes["default"].number,
  minutes: _propTypes["default"].number,
  seconds: _propTypes["default"].number,
  completed: _propTypes["default"].bool
};
var _default = exports["default"] = StickyCountdown;